import { action, computed, observable } from 'mobx';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { WithdrawalApis } from '../../../apis/withdrawals';
import { FieldStateV3 } from '../../../../commonv3/states/form/FormStateV3';
import { StringValidators } from '../../../../commonv3/states/form/validators';
import { ISODate } from '../../../../commonv3/types/dates';
import { SurveyState } from './SurveyState';
import { SubmitState } from '../../../../commonv3/states/SubmitState';

export class WithdrawalSurveyPageState {
    surveyState = new SurveyState();
    surveyKey = 'withdrawal';
    @observable withdrawalApplicableDates = [];
    @observable slackName = new FieldStateV3<string>([StringValidators.required()]);
    @observable lineName = new FieldStateV3<string>([StringValidators.required()]);
    @observable effectiveAt = new FieldStateV3<ISODate>([StringValidators.required()]);
    @observable submitState = new SubmitState();
    @observable success = false;

    @action.bound
    async init() {
        await this.surveyState.init(this.surveyKey);
    }

    @computed
    get hasSurvey(): boolean {
        return !this.surveyState.survey.isEmpty() && !this.surveyState.parameterParseError;
    }

    @action.bound
    async validate() {
        this.slackName.validate();
        this.lineName.validate();
        this.effectiveAt.validate();
    }

    @computed
    get hasErrors(): boolean {
        return [this.slackName, this.lineName, this.effectiveAt].some((field) => field.hasErrors());
    }

    @action.bound
    async submit() {
        const answers = this.surveyState.questions.reduce(
            (result, q) => ({
                ...result,
                [q.survey_question.key]: this.surveyState.getQuestionStateFor(q.survey_question_id).value,
            }),
            {}
        );
        await this.validate();
        await this.surveyState.validate();
        if (!this.surveyState.hasErrors && !this.hasErrors) {
            const surveyKey = this.hasSurvey ? this.surveyState.surveyKey : null;
            this.submitState.operate(async () => {
                await WithdrawalApis.create(
                    this.slackName.getDirtyValue(),
                    this.lineName.getDirtyValue(),
                    this.effectiveAt.getDirtyValue(),
                    surveyKey,
                    this.surveyState.parameters,
                    answers
                );
                this.success = true;
                GlobalStatesV3.routing.push(V3Routes.withdrawalComplete());
            });
        }
    }
}
